
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
    themes: {
      
      light: {
        primary: '#141A1F',
        secondary: '#87B6E6',
        accent: '#0B63BD',
        background: '#FDFDFD',
        links: '#00A9FF',
        fieldcard: '#707A81',
        pop: '#FBC925',
      },
      dark: {
        primary: '#093761',
        secondary: '#87B6E6',
        accent: '#0B63BD',
        background: '#EBF0F0',
        links: '#00A9FF',
        fieldcard: '#707A81',
        pop: '#FF0000',
      },
    },
  },
});

    